import { lazy, Suspense, useState } from 'react'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Loader2, Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet'

const SheetPanel = lazy(() => import('./sheet-panel'))

/** Header button: the assistant in a side panel, over whatever page is open. */
export function AssistantSheet() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)
  if (pathname === '/ai-chat') return null

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="sm" className="text-muted-foreground">
          <Sparkles />
          <span className="hidden sm:inline">{t('v2.assistant.ask')}</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full gap-0 p-0 sm:max-w-md" aria-describedby={undefined}>
        <Suspense
          fallback={
            <>
              <SheetTitle className="sr-only">{t('v2.assistant.title')}</SheetTitle>
              <Loader2 className="m-auto size-5 animate-spin text-muted-foreground" />
            </>
          }
        >
          <SheetPanel onNavigate={() => setOpen(false)} />
        </Suspense>
      </SheetContent>
    </Sheet>
  )
}
